var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page login-page as-flex main-center cross-center" },
    [
      _c(
        "div",
        {
          staticClass:
            "login-box as-flex flex-vertical main-start cross-center",
        },
        [
          _c(
            "swiper",
            {
              ref: "mySwiper",
              staticClass: "login-box-content",
              attrs: { options: _vm.swiperOption },
            },
            [
              _c("swiper-slide", { key: "login" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "login-box-content as-flex flex-vertical main-start cross-center",
                  },
                  [
                    _c("div", { staticClass: "logo as-flex" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/login-logo.png"),
                          width: "100%",
                          height: "100%",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "username as-flex main-center" }, [
                      _c("i", { staticClass: "icon icon-user" }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.username,
                            expression: "username",
                          },
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.username },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.username = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "password as-flex main-center" }, [
                      _c("i", { staticClass: "icon icon-lock" }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password",
                          },
                        ],
                        attrs: { type: "password" },
                        domProps: { value: _vm.password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "function-box as-flex main-between cross-center f-2",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "fucntion-left as-flex main-start cross-center",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.rememberMe,
                                  expression: "rememberMe",
                                },
                              ],
                              staticClass: "checkbox",
                              attrs: { id: "rememberme", type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.rememberMe)
                                  ? _vm._i(_vm.rememberMe, null) > -1
                                  : _vm.rememberMe,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.rememberMe,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.rememberMe = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.rememberMe = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.rememberMe = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "rememberme" } }, [
                              _vm._v("记住我"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "fucntion-right as-flex main-center cross-center",
                            on: { click: _vm.forgetPassword },
                          },
                          [
                            _c("span", [_vm._v("忘记密码")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "login-go-right" }, [
                              _c("i", { staticClass: "icon icon-login-right" }),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "error f-1 fc-red" }, [
                      _vm._v(_vm._s(_vm.error || "")),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "button as-circle login-btn f-3 fc-white as-flex main-center cross-center",
                        on: { click: _vm.login },
                      },
                      [_vm._v("登 录")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("swiper-slide", { key: "passwordOperation" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "login-box-content as-flex flex-vertical main-start cross-center",
                  },
                  [
                    _c("passwordOperation", {
                      staticClass: "as-modal",
                      attrs: { defaultConfig: _vm.defaultPasswordConfig },
                      on: {
                        close: function ($event) {
                          return _vm.changeLoginStatus(false)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "contact-us f-1 as-flex main-center cross-center" },
      [
        _c("a", { attrs: { href: "https://www.fanink.cn/callus" } }, [
          _vm._v("联系我们"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }